import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { LoginModalProps } from '../../components/LoginModal'
import { actions, selectors } from '../../redux'
import { api } from '../../configuration'
import { ActionButtonVariant } from '../../components/ActionButton/styled'
import Router from '../../routes/Router'
import routes from '../../routes/definitions'

const useLoginModal = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isOpen = useSelector(selectors.modals.loginModalIsOpen)

  const handleCloseModal = () => {
    dispatch(actions.modals.setLoginModalIsOpen(false))
  }

  // only shown to visitors who are not connected: connected users without
  // store access are linked straight to the access request form instead
  const props: LoginModalProps = {
    title: t('loginModalTitle'),
    isOpen,
    onClose: handleCloseModal,
    login: {
      title: t('loginModalLoginTitle'),
      subtitle: t('loginModalLoginSubtitle'),
      ecpsConnectionButton: {
        href: `${api.API_URL}/api/connect/${api.AUTH_PROVIDER}`,
        text: t('register_ecps_block_left_button'),
        variant: ActionButtonVariant.quaternary,
      },
      button: {
        href: Router.getRouteUrl(routes.loginOrRegister),
        text: t('loginModalLoginByEmailButton'),
        onClick: handleCloseModal,
      },
      helpText: t('loginModalHelpText'),
      ecpsConnectionIssueLink: {
        label: t('register_ecps_connection_issue_block_left_link_label'),
        href: t('register_ecps_connection_issue_block_left_link_href'),
      },
    },
    register: {
      title: t('loginModalRegisterTitle'),
      subtitle: t('loginModalRegisterSubtitle'),
      button: {
        href: Router.getRouteUrl(routes.loginOrRegister),
        text: t('loginModalLoginByEmailButton'),
        onClick: handleCloseModal,
      },
    },
  }

  return props
}

export default useLoginModal
